import { inject, type Provider } from '@angular/core';
import { tuiValidationErrorsProvider } from '@taiga-ui/core/tokens';

import { I18nService } from '@core/i18n/i18n.service';

export function provideValidationMessages(): Provider {
  return tuiValidationErrorsProvider(() => {
    const i18n = inject(I18nService);

    return {
      required: () => i18n.t('validation.required'),
      email: () => i18n.t('validation.invalidEmail'),
      minlength: ({ requiredLength }: { requiredLength: number }) =>
        i18n.t('validation.minLength', { number: requiredLength }),
      maxlength: ({ requiredLength }: { requiredLength: number }) =>
        i18n.t('validation.maxLength', { number: requiredLength }),
      pattern: () => i18n.t('validation.pattern'),
      server: (message: string) => message,
    };
  });
}
